module.exports = __webpack_public_path__ + "img/NG.edb0fc52.svg";